import React, { useState, useEffect, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Pane, Tablist, Tab, TabNavigation } from "evergreen-ui";
import ControlHubContext from "../contexts/controlhub";
import { API_URL } from "../config";

const routeMap = {
  Dashboard: "/dashboard",
  Reports: "/reports",
  "Audit Logs": "/logs",
  "Approval Matrix": "/approvals",
  Billing: "/billing",
  "Accounts Payable": "/ap",
  Purchases: "/purchases-reports",
  Accounting: "/accounting",
};

const FREE_PLAN_NAME = "free_plan";

function TopNavApp() {
  const history = useHistory();
  const location = useLocation();
  const [currentPath, setCurrentPath] = useState("");
  const { currentCompanyId, currentCompanyPlan } =
    useContext(ControlHubContext);
  const [menuList, setMenuList] = useState([]);
  const [currentTab, setCurrentTab] = useState(null);

  useEffect(() => {
    setCurrentPath(location.pathname);
  }, [location]);

  useEffect(() => {
    if (currentCompanyId) {
      fetch(API_URL + `/admin/companies/${currentCompanyId}/categories`, {
        credentials: "include",
      })
        .then((res) =>
          res.json().then((data) => {
            if (data && data !== "") {
              setMenuList(data);
            }
          })
        )
        .catch((error) => {
          console.log(error);
        });
    }
  }, [currentCompanyId]);

  useEffect(() => {
    if (!currentPath) return;

    const tabSelected = menuList.find(
      (tab) => routeMap[tab.title] === `/${currentPath.split("/")[1]}`
    );

    setCurrentTab(tabSelected);
  }, [currentPath, menuList]);

  const menuListFiltered = menuList.filter((e) => {
    if (e.type === "embeded_url" && e.url === null) {
      return false;
    } else {
      return true;
    }
  });

  return (
    <Pane>
      <Pane display="flex" padding={16} borderBottom background="white">
        <Tablist>
          {menuListFiltered.map((item, index) => (
            <Tab
              key={`tab-${index}`}
              isSelected={
                `/${currentPath.split("/")[1]}` === routeMap[item.title]
              }
              onSelect={() =>
                history.push(item.def_subtab_uri || routeMap[item.title])
              }
            >
              {(currentCompanyPlan === FREE_PLAN_NAME &&
                item.title === "Billing" &&
                "Subscribe") ||
                item.title}
            </Tab>
          ))}
        </Tablist>
      </Pane>

      <Pane paddingX={48} paddingY={16}>
        <TabNavigation margin={4}>
          {currentTab &&
            currentTab.childs_tab &&
            currentTab.childs_tab.map((item, index) => (
              <Tab
                key={`tab-child-${index}`}
                isSelected={`${currentPath.split("/")[2]}` === item.slug}
                onSelect={() =>
                  history.push(`/${currentPath.split("/")[1]}/${item.slug}`)
                }
              >
                {item.title}
              </Tab>
            ))}
        </TabNavigation>
      </Pane>
    </Pane>
  );
}

export default TopNavApp;
